exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-table td {\n\tpadding: 15px !important;\n}\n", ""]);

// exports
